export default "__VITE_ASSET__CNoz2Dxj__"